import { renderDate } from '../utility/personTabGridHelper';

export const ATTACHMENT_GRID_COLUMNS = [
  { field: 'ptsAttachmentID', headerName: 'Attachment ID', width: 150 },
  { field: 'FileName', headerName: 'File Name', width: 240 },
  { field: 'FileType', headerName: 'File Type', width: 140 },
  { field: 'Description', headerName: 'Description', width: 240 },
  { field: 'codeAttachmentType', headerName: 'Type', width: 140 },
  { field: 'Attached', headerName: 'Attached', width: 180, valueFormatter: renderDate },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
  { field: 'IsDeleted', headerName: 'Is Deleted', width: 130, type: 'boolean' },
  { field: 'DeletedBy', headerName: 'Deleted By', width: 150 },
  { field: 'DeletedIP', headerName: 'Deleted IP', width: 150 },
];
